// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .product-width {
    width: 60%;
} */

.cart-product {
  display: flex;
  justify-content: start;
  align-items: center;
  column-gap: 50px;
}

.cart-tab-heads {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: var(--dPink);
  background-color: var(--uPTPink);
  text-transform: uppercase;
  border-radius: 30px;
}

.cart-tab-heads .card-heads p {
  padding: 10px 0px;
  margin-bottom: 0px;
}

.card-heads {
  padding: 0px 10px;
}

.product-thumbnail .product-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cart-product-name {
  width: 50%;
}

.delete-icon {
  margin-bottom: 20px;
  width: 10%;
}

.serial-no h2 {
  font-size: 75px;
  font-weight: 700;
  color: var(--blue);
  opacity: 40%;
}

.product-price-quantity {
  display: flex;
  align-items: center;
  justify-content: space-around;
  column-gap: 30px;
  margin-top: 80px;
}

.border-bottom {
  border-bottom: 5px solid var(--uPTPink) !important;
}

.calc-txt {
  font-size: 20px;
  font-weight: 700;
  color: var(--dPink);
  padding: 10px 0 10px;
}

.product-quantity {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cart-product-name p {
  text-transform: capitalize;
}

.product-quantity span {
  padding: 0px 10px 20px 10px;
}

.product-quantity span.btn {
  cursor: pointer;
}

.delete-icon svg {
  color: var(--dPink);
}

.sub-total,
.total-amt {
  align-items: center;
}

.sub-total-amt {
  padding: 10px 0px;
}

.amount-txt {
  text-align: end;
  padding-right: 45px;
}

.cp-product-price span,
.product-quantity p span,
.sub-total-amt p span {
  display: none;
}

.amt-txt-color {
  color: var(--dBlue);
}

/* Checkout Button  */
.checkout {
  background-color: var(--dBlue);
  color: var(--white);
  font-weight: 600;
  padding: 15px 60px;
  border-radius: 50px;
  text-transform: capitalize;
  font-family: "Poppins";
  font-size: 18px;
  margin: 20px 0px;
}

.checkout-btn {
  text-align: end;
}

.submit-coupon {
  padding: 5px 20px;
  background-color: var(--dBlue);
  color: var(--white);
  font-weight: 600;
  border-radius: 50px;
  text-transform: capitalize;
  font-family: "Poppins";
  font-size: 18px;
  border: none;
}

.coupon-success-wrapper {
  border: 2px solid green;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
}
.coupon-content-wrapper p {
  margin-bottom: 0;
}
.coupon-remove-btn {
  background: transparent;
  border: 0;
  color: var(--dPink);
}

.coupon-success-icon {
  font-size: 40px;
  color: green;
}

.coupon-content-wrapper {
  display: flex;
  column-gap: 20px;
  align-items: center;
}

.cart-product-title {
  font-weight: 500;
}

.cart-product .serial-no {
  width: 10%;
}

.cart-product .product-thumbnail,
.wishlist-product .product-thumbnail {
  width: 30%;
  text-align: center;
  /* padding: 10px; */
}

.cart-product .shortDesc {
  font-size: 14px;
}

.button-loader {
  position: relative;
  /* top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); */
  display: inline-block;
  padding: 15px 25px;
  background: var(--dBlue);
  border: none;
  color: #fff;
  border-radius: 100px;
  cursor: pointer;
  transition: 0.3s ease;
}

.button-loader:after {
  content: "";
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  border: solid 2px;
  border-color: #fff transparent transparent transparent;
  border-radius: 100%;
  transition: 0.3s ease;
  animation: spin 1s infinite;
  transform-origin: 0 0;
}

.button-loader.load {
  padding: 15px 6px;
}

.button-loader.load span {
  opacity: 0;
}

.button-loader.load:after {
  display: block;
}

@keyframes spin {
  from {
    transform: rotate(0) translate(-50%, -50%);
  }
  to {
    transform: rotate(360deg) translate(-50%, -50%);
  }
}

.coupon-detail {
  color: #00000082;
  font-weight: 600;
}

.delete-icon:hover {
  transform: scale(1.3);
}

.continue-shopping {
  border-radius: 30px;
  margin-top: 20px;
  padding: 10px 20px;
}

@media (max-width: 767px) {
  .cart-product {
    column-gap: 30px;
  }

  .border-bottom {
    border-bottom: 0 !important;
    border-bottom: initial !important;
  }

  .cart-value-container {
    background-color: var(--lPink);
    border-radius: 30px;
  }

  .product-price-quantity {
    margin: 10px 0 20px 0px;
  }

  .cp-product-price span,
  .product-quantity p span,
  .sub-total-amt p span {
    display: inline-block;
    font-weight: 700;
    color: var(--dPink);
  }

  .cart-tab-heads {
    display: none;
  }

  .product-quantity span {
    display: none;
    padding: 0px;
  }

  .sub-total,
  .total-amt {
    justify-content: space-between;
  }

  .amount-txt {
    padding-right: 0px;
  }

  .checkout-btn {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/cart-pages/Cart.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB;;;;;;uCAMqC;EACrC,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,eAAe;EAIf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sDAAsD;EACtD,mBAAmB;EAInB,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA+B;IAA/B,iCAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* .product-width {\r\n    width: 60%;\r\n} */\r\n\r\n.cart-product {\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  column-gap: 50px;\r\n}\r\n\r\n.cart-tab-heads {\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: var(--dPink);\r\n  background-color: var(--uPTPink);\r\n  text-transform: uppercase;\r\n  border-radius: 30px;\r\n}\r\n\r\n.cart-tab-heads .card-heads p {\r\n  padding: 10px 0px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.card-heads {\r\n  padding: 0px 10px;\r\n}\r\n\r\n.product-thumbnail .product-thumbnail img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.cart-product-name {\r\n  width: 50%;\r\n}\r\n\r\n.delete-icon {\r\n  margin-bottom: 20px;\r\n  width: 10%;\r\n}\r\n\r\n.serial-no h2 {\r\n  font-size: 75px;\r\n  font-weight: 700;\r\n  color: var(--blue);\r\n  opacity: 40%;\r\n}\r\n\r\n.product-price-quantity {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n  column-gap: 30px;\r\n  margin-top: 80px;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: 5px solid var(--uPTPink) !important;\r\n}\r\n\r\n.calc-txt {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: var(--dPink);\r\n  padding: 10px 0 10px;\r\n}\r\n\r\n.product-quantity {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.cart-product-name p {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.product-quantity span {\r\n  padding: 0px 10px 20px 10px;\r\n}\r\n\r\n.product-quantity span.btn {\r\n  cursor: pointer;\r\n}\r\n\r\n.delete-icon svg {\r\n  color: var(--dPink);\r\n}\r\n\r\n.sub-total,\r\n.total-amt {\r\n  align-items: center;\r\n}\r\n\r\n.sub-total-amt {\r\n  padding: 10px 0px;\r\n}\r\n\r\n.amount-txt {\r\n  text-align: end;\r\n  padding-right: 45px;\r\n}\r\n\r\n.cp-product-price span,\r\n.product-quantity p span,\r\n.sub-total-amt p span {\r\n  display: none;\r\n}\r\n\r\n.amt-txt-color {\r\n  color: var(--dBlue);\r\n}\r\n\r\n/* Checkout Button  */\r\n.checkout {\r\n  background-color: var(--dBlue);\r\n  color: var(--white);\r\n  font-weight: 600;\r\n  padding: 15px 60px;\r\n  border-radius: 50px;\r\n  text-transform: capitalize;\r\n  font-family: \"Poppins\";\r\n  font-size: 18px;\r\n  margin: 20px 0px;\r\n}\r\n\r\n.checkout-btn {\r\n  text-align: end;\r\n}\r\n\r\n.submit-coupon {\r\n  padding: 5px 20px;\r\n  background-color: var(--dBlue);\r\n  color: var(--white);\r\n  font-weight: 600;\r\n  border-radius: 50px;\r\n  text-transform: capitalize;\r\n  font-family: \"Poppins\";\r\n  font-size: 18px;\r\n  border: none;\r\n}\r\n\r\n.coupon-success-wrapper {\r\n  border: 2px solid green;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 20px;\r\n}\r\n.coupon-content-wrapper p {\r\n  margin-bottom: 0;\r\n}\r\n.coupon-remove-btn {\r\n  background: transparent;\r\n  border: 0;\r\n  color: var(--dPink);\r\n}\r\n\r\n.coupon-success-icon {\r\n  font-size: 40px;\r\n  color: green;\r\n}\r\n\r\n.coupon-content-wrapper {\r\n  display: flex;\r\n  column-gap: 20px;\r\n  align-items: center;\r\n}\r\n\r\n.cart-product-title {\r\n  font-weight: 500;\r\n}\r\n\r\n.cart-product .serial-no {\r\n  width: 10%;\r\n}\r\n\r\n.cart-product .product-thumbnail,\r\n.wishlist-product .product-thumbnail {\r\n  width: 30%;\r\n  text-align: center;\r\n  /* padding: 10px; */\r\n}\r\n\r\n.cart-product .shortDesc {\r\n  font-size: 14px;\r\n}\r\n\r\n.button-loader {\r\n  position: relative;\r\n  /* top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    -moz-transform: translate(-50%, -50%);\r\n    -o-transform: translate(-50%, -50%);\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%); */\r\n  display: inline-block;\r\n  padding: 15px 25px;\r\n  background: var(--dBlue);\r\n  border: none;\r\n  color: #fff;\r\n  border-radius: 100px;\r\n  cursor: pointer;\r\n  -webkit-transition: 0.3s ease;\r\n  -moz-transition: 0.3s ease;\r\n  -o-transition: 0.3s ease;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.button-loader:after {\r\n  content: \"\";\r\n  display: none;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 20px;\r\n  height: 20px;\r\n  border: solid 2px;\r\n  border-color: #fff transparent transparent transparent;\r\n  border-radius: 100%;\r\n  -webkit-transition: 0.3s ease;\r\n  -moz-transition: 0.3s ease;\r\n  -o-transition: 0.3s ease;\r\n  transition: 0.3s ease;\r\n  animation: spin 1s infinite;\r\n  transform-origin: 0 0;\r\n}\r\n\r\n.button-loader.load {\r\n  padding: 15px 6px;\r\n}\r\n\r\n.button-loader.load span {\r\n  opacity: 0;\r\n}\r\n\r\n.button-loader.load:after {\r\n  display: block;\r\n}\r\n\r\n@keyframes spin {\r\n  from {\r\n    transform: rotate(0) translate(-50%, -50%);\r\n  }\r\n  to {\r\n    transform: rotate(360deg) translate(-50%, -50%);\r\n  }\r\n}\r\n\r\n.coupon-detail {\r\n  color: #00000082;\r\n  font-weight: 600;\r\n}\r\n\r\n.delete-icon:hover {\r\n  transform: scale(1.3);\r\n}\r\n\r\n.continue-shopping {\r\n  border-radius: 30px;\r\n  margin-top: 20px;\r\n  padding: 10px 20px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .cart-product {\r\n    column-gap: 30px;\r\n  }\r\n\r\n  .border-bottom {\r\n    border-bottom: unset !important;\r\n  }\r\n\r\n  .cart-value-container {\r\n    background-color: var(--lPink);\r\n    border-radius: 30px;\r\n  }\r\n\r\n  .product-price-quantity {\r\n    margin: 10px 0 20px 0px;\r\n  }\r\n\r\n  .cp-product-price span,\r\n  .product-quantity p span,\r\n  .sub-total-amt p span {\r\n    display: inline-block;\r\n    font-weight: 700;\r\n    color: var(--dPink);\r\n  }\r\n\r\n  .cart-tab-heads {\r\n    display: none;\r\n  }\r\n\r\n  .product-quantity span {\r\n    display: none;\r\n    padding: 0px;\r\n  }\r\n\r\n  .sub-total,\r\n  .total-amt {\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .amount-txt {\r\n    padding-right: 0px;\r\n  }\r\n\r\n  .checkout-btn {\r\n    text-align: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
